import {Inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ConfigService} from '../../config/config.service';
import {AUTH_MODULE_OPTIONS_TOKEN, AuthModuleOptions} from '../auth.options';
import {Observable} from 'rxjs';
import {User} from '../../models/user.model';
import {map} from 'rxjs/operators';


export class PasswordChangeRequest {
  new_password: string;
  new_password_confirm: string;
  old_password: string;
}

@Injectable({
  providedIn: 'root'
})
export class ProfileService {

  constructor(
    @Inject(AUTH_MODULE_OPTIONS_TOKEN) private options: AuthModuleOptions,
    private httpClient: HttpClient,
    private config: ConfigService,
  ) {
  }

  public user(): Observable<User> {
    return this.httpClient.get<User>(this.config.apiUrl(this.options.apiMeUrl)).pipe(
      map(r => new User(r))
    );
  }

  public update(values: User): Observable<number> {
    return this.httpClient.put<number>(this.config.apiUrl(this.options.apiMeUrl), values);
  }

  public changePassword(values: PasswordChangeRequest): Observable<void> {
    return this.httpClient.post<void>(this.config.apiUrl(`${this.options.apiMeUrl}/change-password`), values);
  }
}
